/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';

export default function AuthModule(Component) {

    class AuthModule extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                credID: '',
                username: '',
                serviceID: '',
                action: '',
                finalUrl: ''
            };

            this.authReturnHandler = this.authReturnHandler.bind(this);
            this.resetAuthState = this.resetAuthState.bind(this);

        }

        componentDidMount() {

            if (this.props.router.query) {
                let credID = '',
                    finalUrl = '';

                if (this.props.router.query.state !== undefined) {
                    credID = this.props.router.query.state;
                }

                if (this.props.router.query.final !== undefined) {
                    finalUrl = decodeURIComponent(this.props.router.query.final);
                }

                if (this.state.credID !== credID) {
                    this.setState({
                        credID,
                        finalUrl
                    });
                }
            }

        }

        authReturnHandler(redirect, callback, state) {
            let authState = '',
                routeId = 0,
                social = {
                    credID: ''
                },
                input = {
                    credID: ''
                },
                interval = 0,
                route = null,
                parts = [];

            // allow authState key to be passed in
            if (state && state !== '') {
                authState = state;
            } else if (this.state.credID !== '') {
                authState = this.state.credID;
            }

            if (authState) {
                if (this.props.router.params && this.props.router.params.routeId) {
                    routeId = this.props.router.params.routeId;
                }

                parts = authState.split("_");

        		if (authState.match(/^POSTGS/)) {
                    social.psID = parts[1];
                    social.credID = authState;

                    if (this.props.createSocial !== undefined) {
                        this.props.createSocial(social);
                    }

                    this.setState({
                        action: 'confirm'
                    });

                } else if (authState.match(/^POST/)) {
                    // we've landed on the subaccount selector, don't do anything yet
                    if (this.props.router.location.pathname.match(/chooser/)) {
                        return;
                    }
                    social.psID = parts[1];
                    social.credID = authState;

                    if (routeId !== 0) {
                        social.rID = routeId;
                    }
                    if (parts.length >= 4) {
                        social.rID = parts[2];
                    }

                    if (this.props.router.query && this.props.router.query.externalID) {
                        social.externalID = this.props.router.query.externalID;
                    }

                    if (this.props.recordEvent) {
                        let socialName = '',
                            constants = this.props.app.config.constants,
                            context = 'General',
                            onboarding = (typeof(Storage) !== undefined) ? JSON.parse(window.localStorage.getItem('onboarding')) : null;

                        switch (parseInt(social.psID, 10)) {
                            case constants.POST_SVC_TWITTER:
                                socialName = 'Twitter';
                                break;

                            case constants.POST_SVC_FACEBOOK:
                                socialName = 'Facebook';
                                break;

                            case constants.POST_SVC_TUMBLR:
                                socialName = 'Tumblr';
                                break;

                            case constants.POST_SVC_BLOGGER:
                                socialName = 'Blogger';
                                break;

                            case constants.POST_SVC_REDDIT:
                                socialName = 'Reddit';
                                break;

                            case constants.POST_SVC_WORDPRESS:
                                socialName = 'Wordpress';
                                break;

                            case constants.POST_SVC_LINKEDIN:
                                socialName = 'LinkedIn';
                                break;

                            case constants.POST_SVC_PINTEREST:
                                socialName = 'Pinterest';
                                break;

                            case constants.POST_SVC_FEED:
                                socialName = 'Output Feed';
                                break;

                            case constants.POST_SVC_LINKEDINCOMPANIES:
                                socialName = 'LinkedIn Company';
                                break;

                            case constants.POST_SVC_STOCKTWITS:
                                socialName = 'Stock Twits';
                                break;

                            case constants.POST_SVC_TIKTOK:
                                socialName = 'TikTok';
                                break;

                            case constants.POST_SVC_YOUTUBE:
                                socialName = 'YouTube';
                                break;

                            default:
                                socialName = '';
                        }

                        if (onboarding !== null) {
                            context = "Sign Up";
                        }

                        if (this.props.recordEvent) {
                            this.props.recordEvent({
                                pub_id: this.props.user.detail.id,
                                event_name: 'New Social Created',
                                event_data: {
                                    'network': socialName,
                                    'context': context
                                }
                            });
                        }
                    }

                    if (this.props.createSocial !== undefined) {
                        this.resetAuthState();
                        this.props.createSocial(social);
                    }

                    if (callback) {
                        callback.apply(this, [social]);
                    }

        		} else if (authState.match(/^INPUT/) || authState.match(/^REAUTHREUSE/)) {
                    if (this.props.router.query && this.props.router.query.username) {
                        input.username = this.props.router.query.username;
                    }
                    if (this.props.router.query && this.props.router.query.externalID) {
                        input.externalID = this.props.router.query.externalID;
                    }
                    if (this.props.router.query && this.props.router.query.inputId) {
                        input.inputId = parseInt(this.props.router.query.inputId);
                    }
                    input.type = parts[1];
                    if (authState.match(/^REAUTHREUSE/)) {
                        input.type = parts[3];
                    }
                    input.credID = authState;
                    callback.apply(this, [input]);

                } else if (authState.match(/^REAUTHSHORT/)) {
                    callback.apply(this, [authState]);

                } else if (authState.match(/^REAUTHINPUT/)) {
                    if (callback)  {
                        input.id = parts[2];
                        input.credID = authState;
                        callback.apply(this, [input]);
                    } else {
                        this.setState({
                            credID: authState
                        });
                    }

                } else if (authState.match(/^REAUTHGENERIC/)) {
                        let updateConnection = {
                            id: parts[2],
                            gsID: parts[1],
                            credID: authState,
                            activeFlag: 1
                        };

                        this.setState({
                            credID: authState
                        }, () => {
                            if (callback) {
                                callback.apply(this, [updateConnection]);
                            }
                        });

                } else if (authState.match(/^REAUTH/)) {

                    social.id = parts[2];
                    social.credID = authState;
                    social.reauthorize = true;

                    if (parts.length == 5) {
                        this.props.clearNotices({
                            entityId: parts[4]
                        });
                    }

                    // allow a placeholder to be sent in and replaced
                    if (redirect && redirect.path && redirect.path.match(":ID")) {
                        redirect.path = redirect.path.replace(":ID", parts[2]);
                    }

                    this.props.updateSocial(social);

                    if (callback) {
                        callback.apply(this, [social]);
                    }

                } else if (authState.match(/^SHORTEN/)) {

                    callback.apply(this, [parts[1], authState]);

                } else if (authState.match(/^LOGIN/)) {

                    callback.apply(this, [authState, this.props.router.query.username]);

                } else if (authState.match(/^GENERIC/)) {
                    var connection = {
                        gsID: parts[1],
                        credID: authState,
                        username: this.props.router.query.username
                    };

                    this.setState({
                        creating: true
                    }, () => {
                        callback.apply(this, [connection]);
                    });
                }

                if (redirect && redirect.path) {
                    this.props.router.navigate(redirect.path, {
                        replace: true
                    });
                }

            }

        }

        resetAuthState() {
            this.setState({
                credID: '',
                username: '',
                serviceID: '',
                action: ''
            });
        }

        render() {
            return (
                <Component
                    {...this.props}
                    authState={this.state}
                    authReturnHandler={this.authReturnHandler}
                    resetAuthState={this.resetAuthState} />
            );
        }
    }

    AuthModule.displayName = "AuthModule";

    return AuthModule;

}
